import React from "react";
import { Link as GatsbyLink } from "gatsby";
import { trackOutboundLink } from "../../services/gtm";

const Link = ({ children, to, activeClassName, forceBlank, ...other }) => {
  if (typeof to == "string" && !to.includes(".pdf")) {
    if (to) {
      to = to.replace(process.env.GATSBY_ADMIN_URL, "/");
    }
    // const internal = /^\/(?!\/)/.test(to);
    let internal = false;
    if (to.indexOf("/") === 0 || to.indexOf("#") === 0) {
      internal = true;
    }

    if (internal) {
      // add a trailing slash
      // If there isnt one already and there isnt a hash present
      if (
        to.substr(-1) !== "/" &&
        to.includes("#") === false &&
        to.includes("?") === false
      ) {
        to += "/";
      }
      if (to.includes("?") && to.includes("&amp;")) {
        // This is a fix for &amp; encoding issues in internal urls using multiple query parameters
        let path = to.slice(0, to.indexOf("?"));
        let query = to.slice(to.indexOf("?"));
        query = query.replace("&amp;", "&");
        to = path + query;
      }
      return (
        <GatsbyLink to={to} activeClassName={activeClassName} {...other}>
          {children}
        </GatsbyLink>
      );
    } else {
      return (
        <a
          href={to}
          {...other}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackOutboundLink(to)}
        >
          {children}
        </a>
      );
    }
  } else {
    return (
      <a
        href={to}
        {...other}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackOutboundLink(to)}
      >
        {children}
      </a>
    );
  }
};

export default Link;
